import { IReportGridColumn } from "../../models/reports/report.models.base";
import { ColumnOrderState, VisibilityState } from "../react-table.features";

/**
 * Resolves the columns a report export (client-side CSV) should contain, matching exactly what is on
 * screen (RYDE-7777): the visible columns, in the user's chosen order. `columnOrder` holds the active
 * columns in order and `columnVisibility` flags the ones switched off in the Manage Columns drawer —
 * the same source of truth the grid and the server-side CSV use. Internal helper columns
 * (`isHiddenFromView`) are dropped, and keys with no matching layout column are ignored.
 *
 * Pure so it can be unit-tested in isolation and reused by the export hook.
 */
export const getReportExportColumns = ({
  columns,
  columnOrder,
  columnVisibility,
}: {
  columns: IReportGridColumn[];
  columnOrder: ColumnOrderState;
  columnVisibility: VisibilityState;
}): IReportGridColumn[] => {
  if (!columns.length) {
    return [];
  }

  const columnByKey = new Map(
    columns.map(column => [column.uiTableColumn, column]),
  );

  return columnOrder
    .filter(columnKey => columnVisibility[columnKey] !== false)
    .map(columnKey => columnByKey.get(columnKey))
    .filter(
      (column): column is IReportGridColumn =>
        Boolean(column) && !column?.isHiddenFromView,
    );
};
